module.exports = __webpack_public_path__ + "static/img/9.3477c5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hellohr/9.png
// module id = 2DGy
// module chunks = 0